
// Header Parts Collection Filter JavaScript

// --- Dynamic Filter Generation ---
function buildDynamicFilters() {
    if (!window.collectionProducts) return;
    
    const products = window.collectionProducts;
    const categoryMap = {};
    const brandMap = {};
    
    const pageTitle = window.collectionPageTitle || 'Products';
    console.log('\n🔷 ===== BUILDING DYNAMIC FILTERS =====');
    console.log('Collection Page Title:', pageTitle);
    console.log('Number of products:', products.length);
    
    // Debug: Log all unique tags to console
    const allTags = new Set();
    products.forEach(product => {
        product.tags.forEach(tag => allTags.add(tag));
    });
    console.log('All product tags:', Array.from(allTags).sort());
    
    // Log which products have cat: tags
    console.log('\n=== PRODUCTS WITH cat: TAGS ===');
    products.forEach((product, index) => {
        const catTags = product.tags.filter(t => t.startsWith('cat:'));
        if (catTags.length > 0) {
            console.log(`Product ${index}: "${product.title}" (ID: ${product.id})`);
            catTags.forEach(tag => console.log(`  - ${tag}`));
        }
    });
    
    // Build category and brand hierarchies from product tags
    // If this page has a collectionPageTitle (e.g. "Feeder House Parts"), any tag whose
    // top-level segment matches that title is stripped: its children are promoted to become
    // the top-level filter entries so the sidebar never redundantly re-lists the page's own
    // parent category.
    const pageContext = (window.collectionPageTitle || '').trim().toLowerCase();
    console.log('PAGE CONTEXT:', pageContext);

    // Track which subcategories are promoted to top-level, so we can deduplicate them
    const promotedSubcategories = new Set();

    // FIRST PASS: Identify all subcategories that will be promoted to top-level
    products.forEach(product => {
        product.tags.forEach(tag => {
            if (tag.startsWith('cat:')) {
                const catPath = tag.replace('cat:', '').trim();
                const separator = catPath.includes('?') ? '?' : '>';
                const parts = catPath.split(separator).map(p => p.trim());
                
                if (parts.length === 2) {
                    const parentLower = parts[0].toLowerCase();
                    if (pageContext && parentLower === pageContext) {
                        // This child will be promoted to top-level
                        promotedSubcategories.add(parts[1].toLowerCase());
                    }
                } else if (parts.length === 3) {
                    const level0Lower = parts[0].toLowerCase();
                    const level1Lower = parts[1].toLowerCase();
                    
                    if (pageContext && level1Lower === pageContext) {
                        // Level 2 will be promoted to top-level
                        promotedSubcategories.add(parts[2].toLowerCase());
                    }
                }
            }
        });
    });

    console.log('PROMOTED SUBCATEGORIES (will be deduplicated):', Array.from(promotedSubcategories));

    // SECOND PASS: Build the category map, respecting deduplication
    products.forEach(product => {
        product.tags.forEach(tag => {
            // Category tags (format: "cat:Chains>Feeder House Chains" with > or ? separator)
            if (tag.startsWith('cat:')) {
                const catPath = tag.replace('cat:', '').trim();
                // Support both > and ? as separators
                const separator = catPath.includes('?') ? '?' : '>';
                const parts = catPath.split(separator).map(p => p.trim());
                
                console.log(`Processing tag: "${tag}" | parts:`, parts, `| pageContext: "${pageContext}" | Product ID: ${product.id}`);
                
                if (parts.length === 1) {
                    // Single-level category tag
                    const isPageContext = pageContext && parts[0].toLowerCase() === pageContext;
                    console.log(`  Single-level check: "${parts[0].toLowerCase()}" vs "${pageContext}"`, isPageContext ? '✓ SKIP' : '✗ ADD');
                    
                    // SKIP if this category IS the current page context
                    if (isPageContext) {
                        console.log('  → Skipping single-level tag matching page context');
                        return;
                    }

                    // Check if this parent has children that are promoted elsewhere
                    // by looking at other tags on the same product
                    const parentLower = parts[0].toLowerCase();
                    let hasPromotedChildren = false;
                    
                    product.tags.forEach(otherTag => {
                        if (otherTag.startsWith('cat:')) {
                            const otherPath = otherTag.replace('cat:', '').trim();
                            const otherSep = otherPath.includes('?') ? '?' : '>';
                            const otherParts = otherPath.split(otherSep).map(p => p.trim());
                            
                            if (otherParts.length === 2) {
                                const otherParentLower = otherParts[0].toLowerCase();
                                const otherChildLower = otherParts[1].toLowerCase();
                                
                                // If this parent has a child that's promoted elsewhere
                                if (otherParentLower === parentLower && promotedSubcategories.has(otherChildLower)) {
                                    hasPromotedChildren = true;
                                }
                            }
                        }
                    });
                    
                    // If this parent has children promoted elsewhere, skip it
                    if (hasPromotedChildren) {
                        console.log(`  → Single-level parent "${parts[0]}" has children promoted elsewhere, SKIPPING`);
                        return;
                    }

                    // Otherwise, add as a parent category (track unique product IDs)
                    if (!categoryMap[parts[0]]) {
                        categoryMap[parts[0]] = { count: 0, children: {}, productIds: new Set() };
                    }
                    categoryMap[parts[0]].productIds.add(product.id);
                } else if (parts.length === 2) {
                    // Two-level: parent > child
                    const parentLower = parts[0].toLowerCase();
                    const childLower = parts[1].toLowerCase();
                    const isParentPageContext = pageContext && parentLower === pageContext;
                    
                    console.log(`  Two-level check: parent:"${parts[0]}" (${parentLower}) vs pageContext:"${pageContext}" → child:"${parts[1]}"`);
                    
                    if (isParentPageContext) {
                        // Parent matches the current page context
                        // ONLY show the child as a top-level filter item
                        // The parent will be hidden entirely
                        console.log(`  → Parent matches pageContext! Promoting child to top-level ONLY: "${parts[1]}"`);
                        if (!categoryMap[parts[1]]) {
                            categoryMap[parts[1]] = { count: 0, children: {}, productIds: new Set() };
                        }
                        categoryMap[parts[1]].productIds.add(product.id);
                    } else {
                        // Normal case: show parent with nested child (unless child is promoted elsewhere)
                        console.log(`  → Normal hierarchy: parent "${parts[0]}" > child "${parts[1]}"`);
                        
                        // Only add to parent if child is NOT promoted elsewhere
                        // If child is promoted, don't show this parent category at all
                        if (promotedSubcategories.has(childLower)) {
                            console.log(`  → Child "${parts[1]}" is promoted elsewhere, SKIPPING parent entirely`);
                        } else {
                            if (!categoryMap[parts[0]]) {
                                categoryMap[parts[0]] = { count: 0, children: {}, productIds: new Set() };
                            }
                            categoryMap[parts[0]].productIds.add(product.id);
                            
                            if (!categoryMap[parts[0]].children[parts[1]]) {
                                categoryMap[parts[0]].children[parts[1]] = new Set();
                            }
                            categoryMap[parts[0]].children[parts[1]].add(product.id);
                        }
                    }
                } else if (parts.length === 3) {
                    // Three-level: level0 > level1 > level2
                    const level0Lower = parts[0].toLowerCase();
                    const level1Lower = parts[1].toLowerCase();
                    const level2Lower = parts[2].toLowerCase();
                    
                    if (pageContext && level0Lower === pageContext) {
                        // Current page is the top-level category
                        // Show level1 as parent with level2 as child (unless level2 is promoted)
                        console.log(`  → Level-0 matches pageContext! Showing level1 > level2`);
                        
                        // Only add to parent if level2 is NOT promoted elsewhere
                        if (promotedSubcategories.has(level2Lower)) {
                            console.log(`  → Level-2 "${parts[2]}" is promoted elsewhere, SKIPPING level1 parent entirely`);
                        } else {
                            if (!categoryMap[parts[1]]) {
                                categoryMap[parts[1]] = { count: 0, children: {}, productIds: new Set() };
                            }
                            categoryMap[parts[1]].productIds.add(product.id);
                            
                            if (!categoryMap[parts[1]].children[parts[2]]) {
                                categoryMap[parts[1]].children[parts[2]] = new Set();
                            }
                            categoryMap[parts[1]].children[parts[2]].add(product.id);
                        }
                    } else if (pageContext && level1Lower === pageContext) {
                        // Current page is the middle-level category
                        // Show only level2 as a top-level item
                        console.log(`  → Level-1 matches pageContext! Promoting level2 to top-level ONLY: "${parts[2]}"`);
                        if (!categoryMap[parts[2]]) {
                            categoryMap[parts[2]] = { count: 0, children: {}, productIds: new Set() };
                        }
                        categoryMap[parts[2]].productIds.add(product.id);
                    } else {
                        // No context match — show as level0 > level1 (collapse level2, unless level1 is promoted)
                        console.log(`  → No context match. Showing level0 > level1 hierarchy`);
                        
                        // Only add to parent if level1 is NOT promoted elsewhere
                        if (promotedSubcategories.has(level1Lower)) {
                            console.log(`  → Level-1 "${parts[1]}" is promoted elsewhere, SKIPPING level0 parent entirely`);
                        } else {
                            if (!categoryMap[parts[0]]) {
                                categoryMap[parts[0]] = { count: 0, children: {}, productIds: new Set() };
                            }
                            categoryMap[parts[0]].productIds.add(product.id);
                            
                            if (!categoryMap[parts[0]].children[parts[1]]) {
                                categoryMap[parts[0]].children[parts[1]] = new Set();
                            }
                            categoryMap[parts[0]].children[parts[1]].add(product.id);
                        }
                    }
                }
            }
            
            // Brand tags - support both "brand:John Deere" and direct brand names
            if (tag.startsWith('brand:')) {
                const brand = tag.replace('brand:', '').trim();
                if (!brandMap[brand]) {
                    brandMap[brand] = 0;
                }
                brandMap[brand]++;
            } else {
                // Check if tag matches known brand names (case-insensitive, flexible matching)
                const knownBrands = [
                    'John Deere', 'Macdon', 'MacDon', 'New Holland', 'NewHolland',
                    'Case IH', 'CaseIH', 'Case-IH', 'AGCO', 'Claas', 'Perkins', 'Cummins', 'JCB', 'Kubota', 'Cursor'
                ];
                const matchingBrand = knownBrands.find(b => b.toLowerCase().replace(/[\s-]/g, '') === tag.toLowerCase().replace(/[\s-]/g, ''));
                if (matchingBrand) {
                    // Normalize the brand name
                    let normalizedBrand = matchingBrand;
                    if (matchingBrand.toLowerCase().includes('macdon')) normalizedBrand = 'Macdon';
                    if (matchingBrand.toLowerCase().includes('newholland')) normalizedBrand = 'New Holland';
                    if (matchingBrand.toLowerCase().includes('caseih') || matchingBrand.toLowerCase().includes('case ih')) normalizedBrand = 'Case IH';
                    
                    if (!brandMap[normalizedBrand]) {
                        brandMap[normalizedBrand] = 0;
                    }
                    brandMap[normalizedBrand]++;
                }
            }
        });
    });
    
    // Convert productIds Sets to actual counts for each category and child
    // Also create a global child category count (for children that appear under multiple parents)
    const childCategoryGlobalCounts = {};
    
    Object.keys(categoryMap).forEach(parentCat => {
        categoryMap[parentCat].count = categoryMap[parentCat].productIds.size;
        
        Object.keys(categoryMap[parentCat].children).forEach(childCat => {
            const childSet = categoryMap[parentCat].children[childCat];
            categoryMap[parentCat].children[childCat] = childSet.size;
            
            // Track global count for each unique child category name
            if (!childCategoryGlobalCounts[childCat]) {
                childCategoryGlobalCounts[childCat] = new Set();
            }
            // Add all product IDs from this child to global tracking
            childSet.forEach(id => childCategoryGlobalCounts[childCat].add(id));
        });
        
        // Remove the productIds Set after converting to count (for cleaner logging)
        delete categoryMap[parentCat].productIds;
    });
    
    // Now update child counts to use the global count (count unique products across all parents)
    Object.keys(categoryMap).forEach(parentCat => {
        Object.keys(categoryMap[parentCat].children).forEach(childCat => {
            // Replace the count with the global unique count
            categoryMap[parentCat].children[childCat] = childCategoryGlobalCounts[childCat].size;
        });
    });
    
    console.log('Detected brands:', brandMap);
    console.log('Child category global counts:', childCategoryGlobalCounts);
    
    // Create logging version of categoryMap with Sets converted to arrays
    const categoryMapForLogging = {};
    Object.keys(categoryMap).forEach(key => {
        categoryMapForLogging[key] = {
            count: categoryMap[key].count,
            children: categoryMap[key].children
        };
    });
    console.log('CATEGORY MAP (before final cleanup):', categoryMapForLogging);
    
    // Final safety net: Remove any parent categories that match the page context
    // (This catches edge cases where different products might have inconsistent tag formats)
    if (pageContext) {
        const keysToDelete = Object.keys(categoryMap).filter(key => key.toLowerCase() === pageContext);
        keysToDelete.forEach(key => {
            console.log(`🗑️ FINAL CLEANUP: Removing parent category "${key}" that matches pageContext "${pageContext}"`);
            delete categoryMap[key];
        });
    }
    
    console.log('CATEGORY MAP (after final cleanup):', categoryMap);
    console.log('CategoryMap keys after cleanup:', Object.keys(categoryMap));
    
    if (Object.keys(categoryMap).length === 0) {
        console.warn('⚠️ CategoryMap is completely empty after cleanup! This might be intentional if all products are in the page context category.');
    }
    
    // Only replace static filters when products actually have cat: prefixed tags
    if (Object.keys(categoryMap).length > 0) {
        renderCategoryFilters(categoryMap);
    }

    // Render brand filters if any brand tags were detected
    renderBrandFilters(brandMap);
}

function renderCategoryFilters(categoryMap) {
    const container = document.querySelector('.category-filters');
    if (!container) return;
    
    const pageTitle = window.collectionPageTitle || 'Products';
    const pageContext = pageTitle.trim().toLowerCase();
    const isHeaderPartsPage = pageContext === 'header parts';
    
    console.log('=== RENDER CATEGORY FILTERS ===');
    console.log('Page Title:', pageTitle);
    console.log('Page Context:', pageContext);
    console.log('Is Header Parts Page:', isHeaderPartsPage);
    console.log('CategoryMap keys before rendering:', Object.keys(categoryMap));
    
    let html = `<button class="level-1-btn active">${escapeHtml(pageTitle)} <span class="main-icon"></span></button>`;
    html += '<div class="panel-main" style="max-height: 10000px;">';
    
    let renderedCategories = [];
    
    Object.keys(categoryMap).sort().forEach(parentCat => {
        const data = categoryMap[parentCat];
        const hasChildren = Object.keys(data.children).length > 0;
        
        console.log(`\nChecking category: "${parentCat}"`);
        console.log(`  - parentCat.toLowerCase(): "${parentCat.toLowerCase()}"`);
        console.log(`  - pageContext: "${pageContext}"`);
        console.log(`  - isHeaderPartsPage: ${isHeaderPartsPage}`);
        console.log(`  - Match? ${parentCat.toLowerCase() === pageContext}`);
        console.log(`  - Has Children? ${hasChildren}`);
        console.log(`  - Product Count? ${data.count}`);
        
        // Skip main categories that match the page context (except on Header Parts page)
        if (!isHeaderPartsPage && parentCat.toLowerCase() === pageContext) {
            console.log(`  ⏭️ SKIPPING - Category "${parentCat}" matches page context on non-Header Parts page`);
            return;
        }
        
        // Skip parent categories that have no children AND no products
        // (all children were promoted elsewhere and it has no direct products)
        if (!hasChildren && data.count === 0) {
            console.log(`  ⏭️ SKIPPING - Category "${parentCat}" has no children and no products`);
            return;
        }
        
        console.log(`  ✓ RENDERING - Category "${parentCat}"`);
        renderedCategories.push(parentCat);
        
        html += `<div class="filter-group">
            <div class="filter-row" onclick="handleParentClick(this, '${escapeHtml(parentCat)}', 'cat')">
                <div class="filter-checkbox-wrapper">
                    <input type="checkbox">
                    <span class="checkmark"></span>
                </div>
                <span class="item-text parent-text">${escapeHtml(parentCat)} <span class="item-count">(${data.count})</span></span>
                ${hasChildren ? '<span class="arrow-icon">&#9660;</span>' : ''}
            </div>`;
        
        if (hasChildren) {
            html += '<div class="panel-sub">';
            Object.keys(data.children).sort().forEach(childCat => {
                const count = data.children[childCat];
                html += `<div class="sub-row" onclick="handleSubClick('${escapeHtml(childCat)}', 'cat', event)">
                    <div class="filter-checkbox-wrapper"><input type="checkbox"><span class="checkmark"></span></div>
                    <span class="item-text">${escapeHtml(childCat)} <span class="item-count">(${count})</span></span>
                </div>`;
            });
            html += '</div>';
        }
        
        html += '</div>';
    });
    
    html += '</div>';
    
    console.log('Categories actually rendered:', renderedCategories);
    console.log('Total categories in categoryMap:', Object.keys(categoryMap).length);
    console.log('Total categories rendered:', renderedCategories.length);
    
    if (renderedCategories.length === 0) {
        console.warn('⚠️ WARNING: No categories were rendered! Check if all categories are being filtered out.');
    }
    
    container.innerHTML = html;
}

function renderBrandFilters(brandMap) {
    const container = document.querySelector('.category-filters');
    if (!container) return;
    
    // If no brands detected, don't add a brands section
    if (Object.keys(brandMap).length === 0) return;
    
    // Hide brand filters on brand-specific collection pages
    const brandCollections = ['John Deere', 'Case IH', 'MacDon', 'New Holland'];
    const pageTitle = window.collectionPageTitle || '';
    if (brandCollections.includes(pageTitle)) {
        console.log('🚫 Skipping brand filters - on brand-specific page:', pageTitle);
        return;
    }
    
    let html = `<button class="level-1-btn active">Brands <span class="main-icon"></span></button>`;
    html += '<div class="panel-main" style="max-height: 10000px;">';
    
    Object.keys(brandMap).sort().forEach(brand => {
        const count = brandMap[brand];
        html += `<div class="filter-group">
            <div class="filter-row" onclick="handleBrandClick(this, '${escapeHtml(brand)}')">
                <div class="filter-checkbox-wrapper">
                    <input type="checkbox">
                    <span class="checkmark"></span>
                </div>
                <span class="item-text">${escapeHtml(brand)} <span class="item-count">(${count})</span></span>
            </div>
        </div>`;
    });
    
    html += '</div>';
    container.insertAdjacentHTML('beforeend', html);
}

function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

// --- 1. Level 1 Accordion Logic ---
document.addEventListener('DOMContentLoaded', function() {
    // Build dynamic filters first
    console.log('\n📋 ===== DOM CONTENT LOADED - BUILDING FILTERS =====');
    console.log('Collection Page Title set to:', window.collectionPageTitle);
    buildDynamicFilters();

    // Duplicate scroller items for seamless infinite scroll
    const scrollerInner = document.querySelector('.category-scroller-inner');
    if (scrollerInner && scrollerInner.children.length > 0) {
        scrollerInner.innerHTML += scrollerInner.innerHTML;
    }
    
    const level1Btns = document.getElementsByClassName("level-1-btn");
    for (let i = 0; i < level1Btns.length; i++) {
        level1Btns[i].addEventListener("click", function() {
            this.classList.toggle("active");
            const panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            } 
        });
    }

    // Initialize price slider
    initializePriceSlider();
    
    // Initialize sort functionality
    initializeSorting();
});

// --- 2. State & Interaction Logic ---
let state = { cat: null, brand: null, minPrice: 0, maxPrice: 10000 };

// Handle clicking a Parent Row (Category or Brand)
function handleParentClick(row, name, type) {
    const subPanel = row.nextElementSibling;
    const arrow = row.querySelector('.arrow-icon');
    const isSame = state[type] === name;

    if (isSame) {
        // TOGGLE OFF
        state[type] = null;
        if(subPanel && subPanel.classList.contains('panel-sub')) {
            subPanel.classList.remove('show-panel');
            if(arrow) arrow.classList.remove("open");
        }
    } else {
        // TOGGLE ON
        document.querySelectorAll('.panel-sub').forEach(el => el.classList.remove('show-panel'));
        document.querySelectorAll('.arrow-icon').forEach(el => el.classList.remove('open'));

        state[type] = name;
        
        if(subPanel && subPanel.classList.contains('panel-sub')) {
            subPanel.classList.add('show-panel');
            if(arrow) arrow.classList.add("open");
            updateParentHeights(subPanel);
        }
    }
    updateVisuals();
    filterProducts();
}

// Handle clicking a Sub-item
function handleSubClick(name, type, event) {
    event.stopPropagation();
    state[type] = name;
    updateVisuals();
    filterProducts();
}

// Handle clicking a Brand
function handleBrandClick(row, brandName) {
    const isSame = state.brand === brandName;
    
    if (isSame) {
        // Toggle off
        state.brand = null;
    } else {
        // Toggle on
        state.brand = brandName;
    }
    
    updateVisuals();
    filterProducts();
}

function updateParentHeights(element) {
    let parent = element.parentElement;
    while(parent) {
        if(parent.classList.contains('panel-main')) {
            parent.style.maxHeight = (parseInt(parent.scrollHeight) + 500) + "px";
        }
        parent = parent.parentElement;
    }
}

function clearAllFilters() {
    state.cat = null;
    state.brand = null;
    
    // Reset price sliders to defaults
    const minRange = document.getElementById("minRange");
    const maxRange = document.getElementById("maxRange");
    const minPriceDisplay = document.getElementById("minPriceDisplay");
    const maxPriceDisplay = document.getElementById("maxPriceDisplay");
    
    if (minRange && maxRange) {
        state.minPrice = 0;
        state.maxPrice = parseInt(maxRange.max) || 10000;
        minRange.value = 0;
        maxRange.value = maxRange.max;
        
        if (minPriceDisplay) minPriceDisplay.value = 0;
        if (maxPriceDisplay) maxPriceDisplay.value = maxRange.max;
        
        // Update slider track visual
        const sliderTrack = document.getElementById("sliderTrack");
        if (sliderTrack) {
            sliderTrack.style.left = '0%';
            sliderTrack.style.width = '100%';
        }
    }
    
    document.querySelectorAll('.panel-sub').forEach(p => p.classList.remove('show-panel'));
    document.querySelectorAll('.arrow-icon').forEach(a => a.classList.remove('open'));
    updateVisuals();
    filterProducts();
}

function updateVisuals() {
    // Sync Checkboxes
    document.querySelectorAll('input[type="checkbox"]').forEach(cb => {
        cb.checked = false;
        const wrapper = cb.closest('.filter-row, .sub-row');
        if(wrapper) wrapper.classList.remove('checked');
    });

    const allItems = document.querySelectorAll('.filter-row, .sub-row');
    allItems.forEach(item => {
        const label = item.querySelector('.item-text');
        const checkbox = item.querySelector('input[type="checkbox"]');
        if(label && checkbox) {
            const cleanText = label.innerText.split('(')[0].trim();
            if(cleanText === state.cat || cleanText === state.brand) {
                checkbox.checked = true;
                item.classList.add('checked');
            }
        }
    });

    // Sync Tags
    const container = document.getElementById('selectedTagsContainer');
    container.innerHTML = ''; 
    if (state.cat) createTag(state.cat, 'cat');
    if (state.brand) createTag(state.brand, 'brand');

    document.getElementById('clearBtn').style.display = (state.cat || state.brand) ? 'block' : 'none';

    // Update Title
    let text = state.cat ? state.cat : "All Products";
    if (state.brand) text += ` for ${state.brand}`;
    document.getElementById('dynamicTitle').innerText = text;
}

function createTag(name, type) {
    const container = document.getElementById('selectedTagsContainer');
    const tag = document.createElement('span');
    tag.className = type === 'cat' ? 'filter-tag tag-category' : 'filter-tag tag-brand';
    tag.innerHTML = `${name} <i onclick="removeFilter('${type}')">&#10005;</i>`;
    container.appendChild(tag);
}

function removeFilter(type) {
    state[type] = null;
    if(type === 'cat') {
         document.querySelectorAll('.panel-sub').forEach(el => el.classList.remove('show-panel'));
         document.querySelectorAll('.arrow-icon').forEach(el => el.classList.remove('open'));
    }
    updateVisuals();
    filterProducts();
}

// --- Brand Priority Mapping ---
const BRAND_PRIORITY = {
    'john deere': 1,
    'case ih': 2,
    'macdon': 3,
    'new holland': 4
};

function getBrandPriority(product) {
    // Check for brand tags
    if (product.tags && Array.isArray(product.tags)) {
        for (let tag of product.tags) {
            const tagLower = tag.toLowerCase();
            // Check for "brand:BrandName" format
            if (tagLower.startsWith('brand:')) {
                const brandName = tagLower.replace('brand:', '').trim();
                if (BRAND_PRIORITY[brandName] !== undefined) {
                    return BRAND_PRIORITY[brandName];
                }
            }
            // Check for plain brand tags
            if (BRAND_PRIORITY[tagLower] !== undefined) {
                return BRAND_PRIORITY[tagLower];
            }
        }
    }
    // Return high number if brand not in priority list
    return 999;
}

// --- Product Filtering Logic ---
function filterProducts() {
    if (!window.collectionProducts) {
        // Fallback to old method if data not available
        filterProductsFromDOM();
        return;
    }
    
    const products = window.collectionProducts;
    let visibleProducts = products.filter(product => {
        const price = parseFloat(product.price) / 100; // Shopify price is in cents
        const matchesPrice = price >= state.minPrice && price <= state.maxPrice;
        
        let matchesCategory = !state.cat;
        let matchesBrand = !state.brand;
        
        // Check category match - support both "cat:Name" prefixed and plain tags
        if (state.cat) {
            const catLower = state.cat.toLowerCase();
            matchesCategory = product.tags.some(tag => {
                if (tag.startsWith('cat:')) {
                    const catPath = tag.replace('cat:', '').trim();
                    // Support both > and ? as separators
                    const separator = catPath.includes('?') ? '?' : '>';
                    const parts = catPath.split(separator).map(p => p.trim());
                    
                    // Check if category matches at ANY level in the hierarchy
                    // Match exact category name at any position
                    return parts.some(part => part.toLowerCase() === catLower);
                }
                // Also match plain Shopify tags (exact, case-insensitive)
                return tag.trim().toLowerCase() === catLower;
            });
        }

        // Check brand match - support both "brand:Name" prefixed and plain tags
        if (state.brand) {
            const brandLower = state.brand.toLowerCase();
            matchesBrand = product.tags.some(tag => {
                if (tag.startsWith('brand:')) {
                    return tag.replace('brand:', '').trim().toLowerCase() === brandLower;
                }
                // Also match plain brand tags (exact, case-insensitive)
                return tag.trim().toLowerCase() === brandLower;
            });
        }
        
        return matchesCategory && matchesBrand && matchesPrice;
    });
    
    // Sort products: 
    // 1. By brand priority (John Deere > Case IH > Macdon > New Holland)
    // 2. Then by in-stock first, out-of-stock last
    visibleProducts.sort((a, b) => {
        // First, sort by brand priority
        const aBrandPriority = getBrandPriority(a);
        const bBrandPriority = getBrandPriority(b);
        
        if (aBrandPriority !== bBrandPriority) {
            return aBrandPriority - bBrandPriority; // Lower priority number comes first
        }
        
        // If same brand priority, sort by availability (in-stock first)
        const aAvailable = a.available !== false ? 1 : 0;
        const bAvailable = b.available !== false ? 1 : 0;
        return bAvailable - aAvailable; // Reverse order: 1 (available) comes first
    });
    
    // Update the product grid display
    updateProductGrid(visibleProducts);
    
    // Update no products message
    const noProductsMsg = document.querySelector('.no-products');
    if (noProductsMsg) {
        noProductsMsg.style.display = visibleProducts.length === 0 ? 'block' : 'none';
    }
    
    // Update pagination visibility
    updatePaginationVisibility();
}

// Fallback: Filter products from DOM (old method)
function filterProductsFromDOM() {
    const productCards = document.querySelectorAll('.product-card');
    const visibleProducts = [];
    const hiddenProducts = [];
    
    productCards.forEach(card => {
        const price = parseFloat(card.getAttribute('data-price')) || 0;
        const tags = (card.getAttribute('data-tags') || '').toLowerCase();
        const title = (card.getAttribute('data-title') || '').toLowerCase();
        
        let matchesCategory = !state.cat;
        let matchesBrand = !state.brand;
        let matchesPrice = price >= state.minPrice && price <= state.maxPrice;
        
        // Check category match
        if (state.cat) {
            const catLower = state.cat.toLowerCase();
            matchesCategory = tags.includes(catLower) || title.includes(catLower);
        }
        
        // Check brand match
        if (state.brand) {
            const brandLower = state.brand.toLowerCase();
            matchesBrand = tags.includes(brandLower) || title.includes(brandLower);
        }
        
        // Separate visible and hidden products
        if (matchesCategory && matchesBrand && matchesPrice) {
            visibleProducts.push(card);
        } else {
            hiddenProducts.push(card);
            card.style.display = 'none';
        }
    });
    
    // Sort visible products: in-stock first, then out-of-stock
    visibleProducts.sort((a, b) => {
        const aStatus = a.querySelector('.stock-status');
        const bStatus = b.querySelector('.stock-status');
        const aAvailable = !aStatus || !aStatus.classList.contains('out-of-stock') ? 1 : 0;
        const bAvailable = !bStatus || !bStatus.classList.contains('out-of-stock') ? 1 : 0;
        return bAvailable - aAvailable; // Available (1) comes before unavailable (0)
    });
    
    // Reorder DOM: show sorted visible products first
    const gridContainer = document.querySelector('.product-grid');
    if (gridContainer) {
        visibleProducts.forEach(product => {
            gridContainer.appendChild(product);
            product.style.display = 'flex';
        });
    }
    
    // Update the "no products" message
    const noProductsMsg = document.querySelector('.no-products');
    if (noProductsMsg) {
        noProductsMsg.style.display = visibleProducts.length === 0 ? 'block' : 'none';
    }
    
    // Update pagination visibility
    updatePaginationVisibility();
}

// Update product grid with filtered products
function updateProductGrid(products) {
    const gridContainer = document.querySelector('.product-grid');
    if (!gridContainer) return;

    if (products.length === 0) {
        gridContainer.innerHTML = '<div class="no-products"><p>No products found matching your filters.</p></div>';
        return;
    }

    gridContainer.innerHTML = '';

    products.forEach(product => {
        const priceCents = parseFloat(product.price);
        const priceFormatted = '$' + (priceCents / 100).toFixed(2);
        const isAvailable = product.available !== false;
        const variantId = product.variants && product.variants[0] ? product.variants[0].id : '';
        const productUrl = product.url || '/products/' + product.handle;

        let imageSrc = '';
        if (product.featured_image) {
            imageSrc = typeof product.featured_image === 'object'
                ? (product.featured_image.src || '')
                : product.featured_image;
        } else if (product.images && product.images.length > 0) {
            imageSrc = typeof product.images[0] === 'object'
                ? (product.images[0].src || '')
                : product.images[0];
        }
        // Append Shopify size suffix to get a reasonably sized image
        if (imageSrc) {
            imageSrc = imageSrc.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_400x400$1$3');
        }

        const card = document.createElement('div');
        card.className = 'product-card';
        card.setAttribute('data-product-id', product.id);
        card.setAttribute('data-price', (priceCents / 100).toFixed(2));
        card.setAttribute('data-tags', (product.tags || []).join(','));
        card.setAttribute('data-title', product.title);

        card.innerHTML = `
            <div>
                ${imageSrc
                    ? `<img src="${imageSrc}" alt="${escapeHtml(product.title)}" class="product-image" loading="lazy">`
                    : `<img src="/cdn/shop/files/placeholder.png" alt="${escapeHtml(product.title)}" class="product-image">`}
                <div class="product-price">${priceFormatted}</div>
                <a class="product-title" href="${productUrl}">${escapeHtml(product.title)}</a>
                <p class="stock-status${isAvailable ? '' : ' out-of-stock'}">${isAvailable ? 'In Stock' : 'Out of Stock'}</p>
            </div>
            <div class="button-group">
                ${isAvailable && variantId
                    ? `<button class="btn btn-add" onclick="addToCart(${variantId})">Add to cart</button>`
                    : `<button class="btn btn-add" disabled>Out of Stock</button>`}
            </div>
        `;
        gridContainer.appendChild(card);
    });
}

// Update pagination visibility based on active filters
function updatePaginationVisibility() {
    const pagination = document.querySelector('.pagination');
    if (!pagination) return;
    
    // Check if any filters are active
    const hasActiveFilters = state.cat || state.brand || 
                            state.minPrice > 0 || 
                            state.maxPrice < (parseInt(document.getElementById('maxRange')?.max) || 10000);
    
    // Hide pagination when filters are active, show when cleared
    pagination.style.display = hasActiveFilters ? 'none' : 'flex';
}

// --- Price Slider Logic ---
function initializePriceSlider() {
    const minRange = document.getElementById("minRange");
    const maxRange = document.getElementById("maxRange");
    const sliderTrack = document.getElementById("sliderTrack");

    if (!minRange || !maxRange || !sliderTrack) return;

    // Dynamically set slider ceiling from actual product prices so nothing gets
    // accidentally filtered out on initial load (e.g. parts costing > $10,000).
    if (window.collectionProducts && window.collectionProducts.length > 0) {
        const maxProductPrice = Math.max(
            ...window.collectionProducts.map(p => parseFloat(p.price) / 100)
        );
        const dynamicMax = Math.ceil(maxProductPrice / 1000) * 1000 || 10000;
        const sliderMax = Math.max(dynamicMax, 10000);

        minRange.max  = sliderMax;
        maxRange.max  = sliderMax;
        maxRange.value = sliderMax;

        const maxPriceDisplay = document.getElementById("maxPriceDisplay");
        if (maxPriceDisplay) maxPriceDisplay.value = sliderMax;

        state.maxPrice = sliderMax;
    }

    function fillSlider() {
        let p1 = (minRange.value / 10000) * 100;
        let p2 = (maxRange.value / 10000) * 100;
        sliderTrack.style.background = `linear-gradient(to right, #ddd ${p1}%, #d6006e ${p1}%, #d6006e ${p2}%, #ddd ${p2}%)`;
        document.getElementById("minPriceDisplay").value = minRange.value;
        document.getElementById("maxPriceDisplay").value = maxRange.value;
        
        // Update state and filter
        state.minPrice = parseInt(minRange.value);
        state.maxPrice = parseInt(maxRange.value);
        filterProducts();
    }
    
    minRange.addEventListener('input', fillSlider);
    maxRange.addEventListener('input', fillSlider);
    
    // Also listen to direct input changes
    document.getElementById("minPriceDisplay").addEventListener('change', function() {
        minRange.value = this.value;
        fillSlider();
    });
    document.getElementById("maxPriceDisplay").addEventListener('change', function() {
        maxRange.value = this.value;
        fillSlider();
    });
    
    fillSlider();
}

// --- Sorting Functionality ---
function initializeSorting() {
    const sortSelect = document.querySelector('.sort-select');
    if (!sortSelect) return;
    
    sortSelect.addEventListener('change', function() {
        sortProducts(this.value);
    });
}

function sortProducts(sortType) {
    if (!window.collectionProducts) {
        sortProductsFromDOM(sortType);
        return;
    }
    
    // Get currently visible products based on filters
    const products = window.collectionProducts.filter(product => {
        const price = parseFloat(product.price) / 100;
        const matchesPrice = price >= state.minPrice && price <= state.maxPrice;
        
        let matchesCategory = !state.cat;
        let matchesBrand = !state.brand;
        
        if (state.cat) {
            const catLower = state.cat.toLowerCase();
            matchesCategory = product.tags.some(tag => {
                if (tag.startsWith('cat:')) {
                    const catPath = tag.replace('cat:', '').trim();
                    const separator = catPath.includes('?') ? '?' : '>';
                    const parts = catPath.split(separator).map(p => p.trim());
                    
                    // Check if category matches at ANY level in the hierarchy
                    return parts.some(part => part.toLowerCase() === catLower);
                }
                return tag.trim().toLowerCase() === catLower;
            });
        }

        if (state.brand) {
            const brandLower = state.brand.toLowerCase();
            matchesBrand = product.tags.some(tag => {
                if (tag.startsWith('brand:')) {
                    return tag.replace('brand:', '').trim().toLowerCase() === brandLower;
                }
                return tag.trim().toLowerCase() === brandLower;
            });
        }

        return matchesCategory && matchesBrand && matchesPrice;
    });

    // Sort the filtered products
    const sortedProducts = [...products].sort((a, b) => {
        const priceA = parseFloat(a.price) / 100;
        const priceB = parseFloat(b.price) / 100;
        
        switch(sortType) {
            case 'Alphabetical: A-Z':
                return a.title.localeCompare(b.title);
            case 'Alphabetical: Z-A':
                return b.title.localeCompare(a.title);
            case 'Price: Low to High':
                return priceA - priceB;
            case 'Price: High to Low':
                return priceB - priceA;
            default:
                return 0;
        }
    });
    
    updateProductGrid(sortedProducts);
}

function sortProductsFromDOM(sortType) {
    const productGrid = document.querySelector('.product-grid');
    if (!productGrid) return;
    
    const products = Array.from(document.querySelectorAll('.product-card'));
    
    products.sort((a, b) => {
        const titleA = a.getAttribute('data-title') || '';
        const titleB = b.getAttribute('data-title') || '';
        const priceA = parseFloat(a.getAttribute('data-price')) || 0;
        const priceB = parseFloat(b.getAttribute('data-price')) || 0;
        
        switch(sortType) {
            case 'Alphabetical: A-Z':
                return titleA.localeCompare(titleB);
            case 'Alphabetical: Z-A':
                return titleB.localeCompare(titleA);
            case 'Price: Low to High':
                return priceA - priceB;
            case 'Price: High to Low':
                return priceB - priceA;
            default:
                return 0;
        }
    });
    
    products.forEach(product => productGrid.appendChild(product));
}

// --- Add to Cart Functionality ---
function addToCart(variantId) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: variantId,
            quantity: 1
        })
    })
    .then(response => response.json())
    .then(data => {
        // Show success message or update cart UI
        alert('Product added to cart!');
        // You can trigger a cart drawer open here if you have one
    })
    .catch(error => {
        console.error('Error adding to cart:', error);
        alert('Failed to add product to cart. Please try again.');
    });
}

// --- FAQ Accordion Functionality ---
function initializeFAQAccordion() {
    const accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach(item => {
        const header = item.querySelector('.accordion-header');
        
        if (header) {
            header.addEventListener('click', () => {
                const content = item.querySelector('.accordion-content');
                const isCurrentlyOpen = item.classList.contains('is-open');

                // Close all other items
                document.querySelectorAll('.accordion-item.is-open').forEach(openItem => {
                    if (openItem !== item) {
                        openItem.classList.remove('is-open');
                        openItem.querySelector('.accordion-header').setAttribute('aria-expanded', 'false');
                        openItem.querySelector('.accordion-content').style.maxHeight = '0px';
                    }
                });
                
                // Toggle current item
                if (!isCurrentlyOpen) {
                    item.classList.add('is-open');
                    header.setAttribute('aria-expanded', 'true');
                    content.style.maxHeight = content.scrollHeight + 'px';
                } else {
                    item.classList.remove('is-open');
                    header.setAttribute('aria-expanded', 'false');
                    content.style.maxHeight = '0px';
                }
            });
        }
    });
}

// Initialize FAQ when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFAQAccordion);
} else {
    initializeFAQAccordion();
}

// Page Description Read More/Less for Mobile
function initPageDescCollapse() {
    const pageDesc = document.getElementById('page-desc');
    if (!pageDesc) return;

    const para1 = pageDesc.querySelector('.para-1');
    const para2 = pageDesc.querySelector('.para-2');

    // Need at least para-1 to proceed
    if (!para1) return;

    const hasPara2 = !!para2;

    // Create Read More/Read Less buttons if they don't exist
    let readMoreBtn = pageDesc.querySelector('.collection-readmore-btn');
    let readLessBtn = pageDesc.querySelector('.collection-readless-btn');

    if (!readMoreBtn) {
        const buttonContainer = document.createElement('div');
        buttonContainer.style.textAlign = 'center';
        buttonContainer.style.marginTop = '0.5rem';

        readMoreBtn = document.createElement('button');
        readMoreBtn.className = 'collection-readmore-btn';
        readMoreBtn.textContent = 'Read More';

        readLessBtn = document.createElement('button');
        readLessBtn.className = 'collection-readless-btn';
        readLessBtn.textContent = 'Read Less';

        buttonContainer.appendChild(readMoreBtn);
        buttonContainer.appendChild(readLessBtn);

        // Insert after para-2 or para-1 if para-2 doesn't exist
        const insertAfter = para2 || para1;
        insertAfter.parentNode.insertBefore(buttonContainer, insertAfter.nextSibling);
    }

    const setMode = () => {
        if (window.innerWidth <= 768) {
            // Enable buttons on mobile
            if (readMoreBtn) readMoreBtn.style.display = pageDesc.classList.contains('expanded') ? 'none' : 'inline-block';
            if (readLessBtn) readLessBtn.style.display = pageDesc.classList.contains('expanded') ? 'inline-block' : 'none';
            
            // If only para-1 exists, apply line clamp
            if (!hasPara2) {
                para1.style.display = '-webkit-box';
                para1.style.webkitLineClamp = pageDesc.classList.contains('expanded') ? 'unset' : '4';
                para1.style.webkitBoxOrient = 'vertical';
                para1.style.overflow = 'hidden';
            }
        } else {
            // Desktop mode - show all content
            pageDesc.classList.remove('expanded');
            if (hasPara2) {
                para2.style.maxHeight = '';
                para2.style.opacity = '';
                para2.style.marginTop = '';
            } else {
                para1.style.display = '';
                para1.style.webkitLineClamp = '';
                para1.style.webkitBoxOrient = '';
                para1.style.overflow = '';
            }
            if (readMoreBtn) readMoreBtn.style.display = 'none';
            if (readLessBtn) readLessBtn.style.display = 'none';
        }
    };

    setMode();

    // Read More button click
    if (readMoreBtn) {
        readMoreBtn.addEventListener('click', function() {
            if (window.innerWidth > 768) return;

            pageDesc.classList.add('expanded');
            
            if (hasPara2) {
                para2.style.maxHeight = para2.scrollHeight + 'px';
                para2.style.opacity = '1';
                para2.style.marginTop = '1rem';
            } else {
                para1.style.webkitLineClamp = 'unset';
            }
            
            readMoreBtn.style.display = 'none';
            readLessBtn.style.display = 'inline-block';
        });
    }

    // Read Less button click
    if (readLessBtn) {
        readLessBtn.addEventListener('click', function() {
            if (window.innerWidth > 768) return;

            pageDesc.classList.remove('expanded');
            
            if (hasPara2) {
                para2.style.maxHeight = '0';
                para2.style.opacity = '0';
                para2.style.marginTop = '0';
            } else {
                para1.style.webkitLineClamp = '4';
            }
            
            readMoreBtn.style.display = 'inline-block';
            readLessBtn.style.display = 'none';
        });
    }

    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(setMode, 250);
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageDescCollapse);
} else {
    initPageDescCollapse();
}